const getProductPropertySettings = (product_group) =>
  product_group.property_settings.map((property_setting) => {
    if (property_setting.kind === "product_group") {
      const product_group_property =
        product_group.product_group_properties.find(
          (product_group_property) =>
            product_group_property?.property?.id ===
            property_setting?.property?.id,
        );
      return {
        name: property_setting?.property?.internal_name || "-",
        type: "globalna",
        values: [product_group_property?.property_option?.value?.pl].filter(
          Boolean,
        ),
      };
    }
    if (property_setting.kind === "product") {
      const product_property_values = product_group.products.map(
        ({ product_properties }) =>
          product_properties.find(
            (product_property) =>
              product_property.property.id === property_setting?.property?.id,
          )?.property_option?.value?.pl,
      );

      return {
        name: property_setting?.property?.internal_name || "-",
        type: "różnicująca",
        values: product_property_values.filter(Boolean),
      };
    }
    return null;
  });

const getProductGroupSummaryMd = (product_group) => {
  if (!product_group) return "";

  const product_property_settings = getProductPropertySettings(product_group);

  return `**Nazwa produktu grupowego:** ${product_group.name}

**Warianty produktu:**
${product_group.products.map((product) => `- ${product.name}, ${product.ean || "-"}, ${product.producer_code || "-"}`).join("\n")}

**Tabela właściwości:**

|nazwa_parametru | typ | wartosci_parametru |
| :--- | :--- | :--- |
|material_wykonania | globalna | plastik, pvc, polipropylen |
${product_property_settings.map(({ name, type, values }) => `|${name} | ${type} | ${values?.join(", ")}`).join("\n")}`;
};

export default getProductGroupSummaryMd;
